import _extends from "@babel/runtime/helpers/esm/extends";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from "react";
import Login from "./Login"; // eslint-disable-next-line require-await

export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(domNode, rehydrateChildren, _ref) {
    var loginManager, props;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            loginManager = _ref.loginManager;
            props = {
              accountOverviewLabel: domNode.getAttribute("data-account-overview-label"),
              accountLabel: domNode.getAttribute("data-account-label"),
              helloLabel: domNode.getAttribute("data-hello-label"),
              loginLabel: domNode.getAttribute("data-login-label"),
              logoutLabel: domNode.getAttribute("data-logout-label")
            };
            return _context.abrupt("return", /*#__PURE__*/React.createElement(Login, _extends({}, props, {
              loginManager: loginManager
            })));

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
})();